import React from 'react'
import BreadCrumbs from '../../../core/components/breadcrumbs/BreadCrumbs'
import {UniLink} from '../../../core/components/unilink/index'
import './feedChunkCard.css'

export const ProblemFeedChunkCard = ({ e }) => {
  const tryOrTries = e.numAttempts !== 1 ? 'tries' : 'try'
  const action =
    e.actionType === 'correct_answer'
      ? `Solved in ${e.numAttempts} ${tryOrTries}`
      : 'Revealed'
  return (
    <UniLink
      to={`/s/${e.baseTopicId}/problem/${e.problemId}`}
      className="feed-chunk-card">
      <div className="feed-chunk-card__head">
        <BreadCrumbs
          className="feed-chunk-card__breadcrumbs"
          breadcrumbTopics={e.breadcrumbTopics}
          noLink
        />
        <span className='feed-chunk-card__separator'>|</span>
        <span className="feed-chunk-card__action">{action}</span>
      </div>
      <div
        className="feed-chunk-card__body"
        dangerouslySetInnerHTML={{ __html: e.renderedQuestion.text }}
      />
    </UniLink>
  )
}

export const ContributionsFeedChunkCard = ({ e }) => {
  let activityType = e.type
  if (e.type === 'solve_solution') {
    activityType = 'solve solution'
  } else if (e.type === 'problem_solution') {
    activityType = 'problem solution'
  }
  const actionText = e.action === 'edit' ? 'Edited' : 'Wrote'

  const needsArticle =
    e.type === 'problem' ||
    e.type === 'problem_solution' ||
    e.type === 'solve_solution'

  const indefiniteArticle = needsArticle ? 'a' : 'an'
  const bodyText = `${actionText} ${indefiniteArticle} ${activityType} in ${
    e.data.title
  }`

  let href = ''
  if (e.type === 'solve_solution') {
    href = `/solve/${e.data.setNumber}/${e.data.id}`
  } else if (e.type === 'problem_solution') {
    href = `/t/${e.data.topicId}?type=problem&id=${e.data.id}&solution=${e.data.solution}`
  } else {
    href = `/t/${e.data.topicId}?type=${e.type}&id=${e.data.id}`
  }
  return (
    <UniLink
      to={href}
      className="feed-chunk-card">
      <div className="feed-chunk-card__head">
        {e.data.breadcrumbs ? (
          <BreadCrumbs
            className="feed-chunk-card__breadcrumbs"
            breadcrumbTopics={e.data.breadcrumbs}
            noLink
          />
        ) : null}
      </div>
      <div
        className="feed-chunk-card__body"
        dangerouslySetInnerHTML={{ __html: bodyText }}
      />
    </UniLink>
  )
}

export const LoadingFeedChunkCard = () => {
  return (
    <div className="feed-chunk-card feed-chunk-card--loading">
      <div className="feed-chunk-card__head feed-chunk-card__head--loading" />
      <div className="feed-chunk-card__body feed-chunk-card__body--loading" />
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/domains/user/components/FeedChunkCard.js